import React, { useContext } from 'react';
let FeatureFlagsContext;
const initFeatureFlagsContext = (flagsContext) => {
    FeatureFlagsContext = React.createContext(flagsContext);
    return FeatureFlagsContext;
};
const useFeatureFlags = () => {
    if (!FeatureFlagsContext) {
        initFeatureFlagsContext({ launchdarklyFlags: {} });
    }
    const featureFlagsContext = useContext(FeatureFlagsContext);
    return {
        flags: featureFlagsContext.launchdarklyFlags,
    };
};
export { useFeatureFlags, FeatureFlagsContext, initFeatureFlagsContext };
//# sourceMappingURL=feature-flags-context.js.map